export const DynamicNavbar = {
  extends: 'Navbar',
  position: 'sticky',
  top: '0',
  fontSize: 'Y2',
  margin: '- -Y1',
  padding: 'X2 0 0',
  theme: null,
  NavbarButtonSet: {
    width: '100%',
    childProps: {
      padding: 'Y'
    },
    Back: {
      icon: 'arrow angle left',
      ariaLabel: (el) => el.call('polyglot', 'common.action.back'),
      hasBack: (el, s) => {
        return s.recentsIndex < s.recents.length - 1
      },
      '!hasBack': {
        opacity: '0.35',
        pointerEvents: 'none'
      },
      onClick: (ev, el, s) => {
        const recents = s.recents
        s.recentsIndex++
        const prev = recents?.[s.recentsIndex]
        if (prev) {
          el.setWindow('explorer', prev, {
            skipRecentsIndexing: true
          })
        }
      }
    },
    Forward: {
      icon: 'arrow angle right',
      ariaLabel: (el) => el.call('polyglot', 'common.action.forward'),
      hasForward: (el, s) => {
        return s.recentsIndex > 0
      },
      '!hasForward': {
        opacity: '0.35',
        pointerEvents: 'none'
      },
      onClick: (ev, el, s) => {
        const recents = s.recents
        s.recentsIndex--
        const next = recents?.[s.recentsIndex]
        if (next) {
          el.setWindow('explorer', next, {
            skipRecentsIndexing: true
          })
        }
      }
    },
    Close: {
      margin: '- - - auto',
      icon: 'crossmark',
      ariaLabel: (el) => el.call('polyglot', 'common.action.close'),
      onClick: (ev, el) => el.closeWindow('explorer')
    }
  }
}
